import request from '../utils/request'
export async function GetMenuString () {
  const data = {
    strCode: 'WEBV1001',
    json: 'WEB'
  }
  return request({
    url: '/ExecWebMethod',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Menu.js